import { render, staticRenderFns } from "./EquivalentTransfer.vue?vue&type=template&id=0445843b&scoped=true&"
import script from "./EquivalentTransfer.vue?vue&type=script&lang=js&"
export * from "./EquivalentTransfer.vue?vue&type=script&lang=js&"
import style0 from "./EquivalentTransfer.vue?vue&type=style&index=0&id=0445843b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445843b",
  null
  
)

export default component.exports